import React from 'react';
import styled from 'styled-components';
import useDesktop from '@components/shared/useDesktop';
import { PADS_TECH_SPECIFICS_IMAGE_2160, PADS_TECH_SPECIFICS_IMAGE_2882, PADS_TECH_SPECIFICS_IMAGE_1602 } from '@constants';

type Props = {};

const PadsTechSpecifics: React.FC<Props> = () => {
  const isLargestImage = useDesktop(1080);
  const isMiddleImage = useDesktop(800);
  let image = PADS_TECH_SPECIFICS_IMAGE_1602;

  if (isLargestImage) {
    image = PADS_TECH_SPECIFICS_IMAGE_2882;
  } else if (isMiddleImage) {
    image = PADS_TECH_SPECIFICS_IMAGE_2160;
  }

  return (
    <Wrapper>
      <InnerWrapper>
        <img src={image} alt="Pads Tech Specifics" />
      </InnerWrapper>
    </Wrapper>
  );
};

export default PadsTechSpecifics;

const Wrapper = styled.div`
  background-color: #d06aa8;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  overflow: hidden;

  @media (max-width: 800px) {
    align-items: flex-start;
  }
`;

const InnerWrapper = styled.div`
  max-width: 1440px;
  width: 100%;
  display: flex;

  img {
    min-width: 800px;

    @media (max-width: 600px) {
      height: 570px;
      min-width: 600px;
    }
  }
`;
